import React from 'react';

export default function SocialButtons2 () {
  const iconSize = "60px";

  return (
    <div className='flex'>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
        width={iconSize}
        height={iconSize}
        className="mt-6 ml-[1.65rem] fill-[#C19A6B] hover:fill-[#03A9F4] duration-300 ease-in-out"
      >
        {/* ... */}
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
        width="85px"
        height="85px"
        className="mt-6 ml-[1.65rem] fill-[#C19A6B] hover:fill-[#cc39a4] duration-300 ease-in-out"
      >
        {/* ... */}
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
        width="42px"
        height="42px"
        className="mt-[1.8rem]  fill-[#C19A6B] hover:fill-[#40C351] duration-300 ease-in-out"
      >
        {/* ... */}
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
        width="90px"
        height="90px"
        className="mt-6 ml-[1.65rem] fill-[#C19A6B] hover:fill-black duration-300 ease-in-out"
      >
        {/* ... */}
      </svg>
    </div>
  );
}
